import Typography from "@mui/material/Typography";
import { dateShortString } from "utils/date-format";

const Date = ({ value, className, color }) => {
	return (
		<Typography className={className} color={color}>
			{dateShortString(value)}
		</Typography>
	);
};

export default Date;
